function decimalSeparator (locale = navigator.language) {
    const formatted = new Intl.NumberFormat(locale).format(1.1)
    return formatted.replace(/\d/g, '')[0] || '.'
} 

export default decimalSeparator;